// removed by extract-text-webpack-plugin
module.exports = {"footer":"_1f0t0xZ2cRmdVWQL0nfWTX","link":"_1IbL1iXvuh5FIQDPCi0iwC","tinyLink":"_3DQo7SexOsSdqphQ3pEbhY","linkIcon":"_1t60gAcgJLarevLMBEiGaC"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/SideMenu/core/footer/styles.scss
// module id = ./node_modules/wix-style-react/dist/es/src/SideMenu/core/footer/styles.scss
// module chunks = 0